import * as React from 'react';
import { observer } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';

const BadgeWrapper = styled<any, any>('div') `
    ${propStyles};
`;

BadgeWrapper.defaultProps = {
    fontSize: "xs",
    fontFamily: "body",
    fontWeight: "normal",
    textAlign: "center",
    padding: "0.25em 0.5em",
    minWidth: "2em",
    color: "white",
    bgColor: "gray500",
    borderRadius: "3em"
};

export const Badge: React.SFC<any> = ({ theme, children, ...props }) => (
    <BadgeWrapper
        {...theme.Badge}
        {...props}
    >
        {children}
    </BadgeWrapper>
);

export default observer(withTheme(Badge)) as any;


// WEBPACK FOOTER //
// ./src/Components/Badge.tsx